import originAxios from 'axios';
import { DEFAULTCONFIG } from './config.js';
import { getStorage } from '@/common/utils/storage.js'
import { Notification } from 'element-ui';
export default function axios(option) {

  return new Promise(async (resolve, reject) => {

    // 创建axios的实例
    const instance = originAxios.create(DEFAULTCONFIG);

    // 添加请求拦截器
    instance.interceptors.request.use(config => {
      // 在发送请求之前做些什么
      const token = getStorage('token');
      if (token) config.headers['Authorization'] = token;
      return config;
    }, error => {
      // 对请求错误做些什么
      return error;
    });

    // 添加响应拦截器
    instance.interceptors.response.use(response => {
      // 对响应数据做点什么
      return response;
    }, error => {
      // 对响应错误做点什么
      if (error.response) {
        const status = error.response.status;
        const message = error?.response?.data?.message || error?.message;
        switch (status) {
          case 400:
            Notification.error(message || ("发出的请求有错误，服务器没有进行新建或修改数据的操作==>" + status))
            break;
          case 401: //重定向
          Notification.error(message || ("token:登录失效==>" + status))
            break;
          case 403:
            Notification.error(message || ("用户得到授权，但是访问是被禁止的==>" + status))
            break;
          case 404:
            Notification.error(message || ("网络请求不存在==>" + status))
            break;
          case 406:
            Notification.error(message || ("请求的格式不可得==>" + status))
            break;
          case 410:
            Notification.error(message || ("请求的资源被永久删除，且不会再得到的==>" + status))
            break;
          case 422:
            Notification.error(message || ("当创建一个对象时，发生一个验证错误==>" + status))
            break;
          case 500:
            Notification.error(message || ("服务器发生错误，请检查服务器==>" + status))
            break;
          case 502:
            Notification.error(message || ("网关错误==>" + status))
            break;
          case 503:
            Notification.error(message || ("服务不可用，服务器暂时过载或维护==>" + status))
            break;
          case 504:
            Notification.error(message || ("网关超时==>" + status))
            break;
          default:
            Notification.error(message || ("其他错误错误==>" + status))
        }
        return Promise.reject(error?.response?.data);
      }
    });

    // 处理不同的请求方式
    option.method = option.method ? option.method.toUpperCase() : DEFAULTCONFIG.method;
    let CONFIG = {
      ...DEFAULTCONFIG,
      ...option
    }
    if (option.method !== 'GET') {
      CONFIG.data = CONFIG.params;
      delete CONFIG.params;
    }
    // 传入对象进行网络请求
    instance(CONFIG).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}